<script>
import ToppingsModal from '@components/modals/toppings-modal'
export default {
  components: { ToppingsModal },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      checkbox: false,
      complainedUnits: 1,
      quantity: 1,
      selectedProduct: {},
      selectedToppings: [],
    }
  },
  computed: {
    hasToShowModal: function () {
      if (!this.product.toppings) return false
      return this.product.toppings.length > 0 && this.checkbox
    },
    hasToShowCounter: function () {
      return (
        (this.product.units || this.product.pivot.units) > 1 && this.checkbox
      )
    },
    hasToShowCheckbox: function () {
      return (
        ((this.product.units || this.product.pivot.units) === 1 &&
          this.checkbox) ||
        !this.checkbox
      )
    },
    computedProduct () {
      return this.checkbox
        ? Object.assign({}, this.selectedProduct, {
          toppings: this.selectedToppings,
          complainedUnits: this.complainedUnits,
          quantity: this.quantity,
          include: true,
        })
        : Object.assign({}, this.product, {
          include: false,
        })
    },
    productHaveImage () {
      return this.product.image.indexOf('NO-IMAGE') === -1
    },
  },
  watch: {
    hasToShowModal () {
      return this.hasToShowModal ? this.showToppingsModal() : ''
    },
    checkbox: 'emitSelectionChange',
    computedProduct () {
      this.$emit('productUpdate', this.computedProduct)
    },
  },
  created () {
    if (!this.productHaveImage) this.imageFallBack()
  },
  methods: {
    showToppingsModal: function () {
      this.$modal.show(
        ToppingsModal,
        {
          product: this.product,
          toppingsUpdate: toppings => {
            this.selectedToppings = toppings
          },
        },
        {
          height: 'auto',
          width: '90%',
          clickToClose: false,
          scrollable: true,
        },
        {
          'before-close': event => { },
        }
      )
    },
    cleanSelection: function () {
      return (this.computedProduct = {})
    },
    increaseUnit: function () {
      if (this.complainedUnits < (this.product.units || this.product.pivot.units)) {
        this.complainedUnits++
        this.quantity++
      }
    },
    decreaseUnit: function () {
      if (this.complainedUnits > 1) {
        this.complainedUnits--
        this.quantity--
      }
    },
    emitSelectionChange: function () {
      this.selectedProduct = this.checkbox
        ? Object.assign({}, this.product)
        : null
    },
    imageFallBack: function () {
      this.product.image =
        'https://lupe.rappi.com/assets/images/default-product.png'
    },
  },
}
</script>

<template
  class="product"
>

  <v-list-tile slot="activator">
    <v-flex xs1>
      <img
        :src="product.image"
        style="max-height: 2rem; max-width: 2rem;"
        @error="imageFallBack()"
      >
    </v-flex>
    <v-flex
      xs9
      offset-xs1
    >
      <p class="product__name">{{ product.name }}</p>
    </v-flex>
    <v-flex
      :xs2="hasToShowCheckbox"
      :xs5="hasToShowCounter"
    >

      <p-check
        v-if="hasToShowCheckbox"
        v-model="checkbox"
        class="p-icon p-curve p-smooth checkbox"
      >
        <i
          slot="extra"
          class="icon material-icons checkbox__i"
        >done</i>

      </p-check>
      <div
        v-if="hasToShowCounter"
        class="counter"
      >
        <button
          class="counter__button"
          @click="decreaseUnit"
        >
          <img
            src="@assets/images/iconMinus@2x.png"
            style="max-height: 1.4rem; max-width: 1.4rem;"
          >
        </button>
        <div class="counter__text">
          {{ complainedUnits }} <span>/ {{ product.units || product.pivot.units }}</span>
        </div>
        <button
          class="counter__button"
          @click="increaseUnit"
        >
          <img
            src="@assets/images/iconPlus@2x.png"
            style="max-height: 1.4rem; max-width: 1.4rem;"
          >
        </button>
      </div>
    </v-flex>
  </v-list-tile>
</template>

<style lang="scss" scopped>
@import '@design';

.text {
  margin: 0;
  color: $darker-gray;

  @extend %typography-small;
}

.counter {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  height: 2rem;
  padding: 0.2rem;
  background-color: $white;
  border: 1px solid $divider-gray;
  border-radius: 5px;

  &__text {
    margin: 0 !important;
    font-size: 0.8rem;
    text-align: center;

    span {
      color: $blue-gray;
    }

    @extend %typography-xsmall;
  }
  &__button {
    &:hover {
      // transform: translateY(-0.2rem);
      &::after {
        opacity: 0;
        transform: scaleX(1.4) scaleY(1.4);
      }
    }
    &:active {
      transform: translateY(-0.1rem);
    }
    &:focus {
      outline: none;
    }
  }
}

.input {
  background-color: $white;
  border: 1px solid $divider-gray;
  border-radius: 5px;
}

.product {
  width: 20rem;
  color: black;

  &__name {
    display: inline-block;
    max-height: 3.2em;
    margin: 0;
    overflow: hidden;
    line-height: 1.6em;
    color: $darker-gray;
    text-overflow: ellipsis;
    text-align: left;

    @extend %typography-small;
  }
}

.checkbox {
  margin-bottom: 0;
  float: right;

  &__i {
    color: $white;
    border-radius: 2px;
  }
}
</style>
